import { http } from '../../config/axios'

export default function getConsultaLoteDownloadResultado(id:string) :Promise<Blob>{
    return http.get('/api/consultalote/download/' + id, {
        responseType: 'blob'
    })
    .then((r) => r.data)
    .then((blobFile) => {
        return blobFile
    })
    .catch((error) => {
        console.error('Erro ao getConsultaLoteDownloadResultado response')
        return new Blob()
    })
}